import Vue from 'vue'
import Vuex from 'vuex'
import router, {resetRouter} from "@/router";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        currentPathName: '',
        showLoginModal: false, // 控制登录弹窗显示
        // 文章生成全局状态
        articleGen: {
            loading: false,
            result: '',
            title: '',
            outlineLoading: false,
            tocTreeData: [],
            progress: '',
            sections: [], // 存储段落数据
            form: {
                title: '',
                description: '',
                keywords: '',
                references: '',
                templateMode: 'none'
            }
        },
        // 任务书生成全局状态
        taskBook: {
            loading: false,
            result: '',
            progress: '',
            sections: [], // 存储段落数据
            form: {
                title: '',
                description: '',
                references: '',
                columns: [
                    { title: '研究目的', wordLimit: 300 },
                    { title: '研究意义', wordLimit: 300 },
                    { title: '国内外研究进展和趋势', wordLimit: 800 },
                    { title: '技术要求', wordLimit: 400 },
                    { title: '研究思路', wordLimit: 400 },
                    { title: '研究方法', wordLimit: 400 }
                ]
            }
        },
        // 测试用例生成全局状态
        testCase: {
            loading: false,
            progress: '',
            sections: [], // 存储生成的测试用例（三线表格式）
            showExample: false,
            form: {
                projectName: '',
                moduleList: [],
                description: '',
                caseCount: 4,
                tableStartNumber: '6-1',
                fields: [
                    { title: '编号' },
                    { title: '测试内容' },
                    { title: '输入数据' },
                    { title: '预期结果' },
                    { title: '实际结果' }
                ]
            }
        },
        // 降重降AIGC全局状态
        reduceAigc: (() => {
            try {
                const saved = JSON.parse(localStorage.getItem('reduceAigc') || '{}')
                return {
                    mode: saved.mode || '',
                    inputText: saved.inputText || '',
                    outputText: saved.outputText || '',
                    inputText2: saved.inputText2 || '',
                    outputText2: saved.outputText2 || ''
                }
            } catch (e) {
                return {
                    mode: '',
                    inputText: '',
                    outputText: '',
                    inputText2: '',
                    outputText2: ''
                }
            }
        })()
    },
    mutations: {
        setPath (state) {
            state.currentPathName = localStorage.getItem("currentPathName")
        },
        setShowLoginModal(state, show) {
            state.showLoginModal = show
        },
        logout() {
            localStorage.removeItem("user")
            localStorage.removeItem("menus")
            router.push("/")
            resetRouter()
        },
        setArticleGenLoading(state, loading) {
            state.articleGen.loading = loading
        },
        setArticleGenResult(state, result) {
            state.articleGen.result = result
        },
        setOutlineLoading(state, loading) {
            state.articleGen.outlineLoading = loading
        },
        setTocTreeData(state, data) {
            state.articleGen.tocTreeData = data
        },
        appendArticleGenResult(state, text) {
            state.articleGen.result += text
        },
        setArticleGenTitle(state, title) {
            state.articleGen.title = title
        },
        setArticleGenForm(state, form) {
            state.articleGen.form = { ...form }
        },
        clearArticleGen(state) {
            state.articleGen.result = ''
            state.articleGen.title = ''
            state.articleGen.progress = ''
            state.articleGen.sections = []
        },
        setArticleGenProgress(state, msg) {
            state.articleGen.progress = msg
        },
        setArticleGenSections(state, sections) {
            state.articleGen.sections = sections.map(s => ({ ...s }))
        },
        updateArticleGenSection(state, { index, content }) {
            if (state.articleGen.sections[index]) {
                state.articleGen.sections[index].content = content
            }
        },
        // 任务书相关 mutations
        setTaskBookLoading(state, loading) {
            state.taskBook.loading = loading
        },
        setTaskBookResult(state, result) {
            state.taskBook.result = result
        },
        appendTaskBookResult(state, text) {
            state.taskBook.result += text
        },
        setTaskBookProgress(state, msg) {
            state.taskBook.progress = msg
        },
        setTaskBookForm(state, form) {
            state.taskBook.form = {
                title: form.title,
                description: form.description,
                references: form.references || '',
                columns: form.columns.map(col => ({ ...col }))
            }
        },
        clearTaskBook(state) {
            state.taskBook.result = ''
            state.taskBook.progress = ''
            state.taskBook.sections = []
        },
        setTaskBookSections(state, sections) {
            state.taskBook.sections = sections.map(s => ({ ...s }))
        },
        updateTaskBookSection(state, { index, content }) {
            if (state.taskBook.sections[index]) {
                state.taskBook.sections[index].content = content
            }
        },
        // 测试用例相关 mutations
        setTestCaseLoading(state, loading) {
            state.testCase.loading = loading
        },
        setTestCaseProgress(state, msg) {
            state.testCase.progress = msg
        },
        setTestCaseForm(state, form) {
            state.testCase.form = {
                projectName: form.projectName,
                moduleList: [...form.moduleList],
                description: form.description,
                caseCount: form.caseCount,
                tableStartNumber: form.tableStartNumber,
                fields: form.fields.map(f => ({ ...f }))
            }
        },
        setTestCaseSections(state, sections) {
            state.testCase.sections = sections.map(s => ({
                title: s.title,
                description: s.description,
                rows: s.rows ? s.rows.map(r => ({ ...r })) : []
            }))
        },
        clearTestCase(state) {
            state.testCase.progress = ''
            state.testCase.sections = []
        },
        setTestCaseShowExample(state, show) {
            state.testCase.showExample = show
        },
        // 降重降AIGC相关 mutations
        setReduceAigcMode(state, mode) {
            state.reduceAigc.mode = mode
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        setReduceAigcInputText(state, text) {
            state.reduceAigc.inputText = text
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        setReduceAigcOutputText(state, text) {
            state.reduceAigc.outputText = text
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        setReduceAigcInputText2(state, text) {
            state.reduceAigc.inputText2 = text
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        setReduceAigcOutputText2(state, text) {
            state.reduceAigc.outputText2 = text
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        clearReduceAigc(state) {
            state.reduceAigc = {
                mode: '',
                inputText: '',
                outputText: '',
                inputText2: '',
                outputText2: ''
            }
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        },
        clearReduceAigc2(state) {
            state.reduceAigc.inputText2 = ''
            state.reduceAigc.outputText2 = ''
            localStorage.setItem('reduceAigc', JSON.stringify(state.reduceAigc))
        }
    }
})

export default store
